<template>
  <div id="content" class="content" style="margin-left:0px;">
    <h1 class="page-header" style="text-align:left">
      商城管理
      <small>/&nbsp;Logo配置</small>
    </h1>
    <div
      id="page-container"
      class="in page-sidebar-fixed page-header-fixed"
      style="padding-top:0px;"
    >
      <!-- begin #content -->
      <div
        id="content"
        class="content"
        style="margin-left:0px;padding-top: 0px;padding-left:0px;padding-right:0px;"
      >
        <!-- begin breadcrumb -->

        <div class="row">
          <!-- begin col-10 -->
          <div class="col-lg-12">
            <!-- begin panel -->
            <div class="panel panel-inverse">
              <!-- begin panel-heading -->
              <div class="panel-heading">
                <div class="panel-heading-btn">
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-default"
                    data-click="panel-expand"
                  >
                    <i class="fa fa-expand"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-success"
                    data-click="panel-reload"
                  >
                    <i class="fa fa-redo"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-warning"
                    data-click="panel-collapse"
                  >
                    <i class="fa fa-minus"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-danger"
                    data-click="panel-remove"
                  >
                    <i class="fa fa-times"></i>
                  </a>
                </div>
                <h4 class="panel-title panelTitle">Logo配置列表</h4>
              </div>
              <!-- end panel-heading -->

              <!-- begin panel-body -->
              <div class="panel-body">
                <a
                  class="btn btn-primary ButtonColor"
                  @click="AddClick()"
                  style="float:right;margin-bottom:16px;"
                >新增</a>
                <el-table :data="UserManagementList" border style="width: 100%">
                  <el-table-column prop="ordernumber" label="序号"  width="60" align="center"></el-table-column>
                  <el-table-column label="主logo" width="150" align="center">
                    <template slot-scope="scope">
                      <img :src="scope.row.logoUrl" @click="EnlargeImg(scope.row)" class="LogoImg">
                    </template>
                  </el-table-column>
                  <el-table-column prop="title" label="主logo标题" align="center"></el-table-column>
                  <el-table-column prop="subTitle" label="副标题" align="center"></el-table-column>
                  <el-table-column prop="description" label="描述" align="center"></el-table-column>
                  <el-table-column label="操作" width="140" align="center">
                    <template slot-scope="scope">
                      <button
                        class="btn btn-primary btn-sm ButtonColor"
                        data-toggle="modal"
                        :disabled="scope.row.disabled"
                        @click="ApplyClick(scope.row)"
                      >{{scope.row.currentstatus}}</button>
                     
                      <button
                        class="btn btn-warning btn-sm ButtonColor"
                        data-toggle="modal"
                        @click="DeleteClick(scope.row)"
                      >删除</button>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="PaginationStyle">
                  <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageindex"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    background
                    :total="totalCount"
                  ></el-pagination>
                </div>
              </div>
              <!-- end panel-body -->
            </div>
            <!-- end panel -->
          </div>
          <!-- end col-10 -->
        </div>
        <!-- end row -->
      </div>
      <!-- end #content -->
    </div>
    <el-dialog title :visible.sync="outerVisible" width="500px" :before-close="handleClose">
      <div v-if="EditDialog === 3">
        <img :src="CurrentSelection.logoUrl" style="width:400px;">
      </div>

      <div v-if="EditDialog === 2" class="ModelPadding">
        <div class="swal-icon swal-icon--info"></div>
        <div class="swal-title">您确定吗?</div>
        <div class="swal-text" style="text-align:center">您将无法恢复这个文件!</div>
        <div class="swal-footer"> 
          <div class="swal-button-container">
            <button class="swal-button swal-button--confirm btn btn-primary" @click="MakeSure" :disabled = "disabled">确定</button>
          </div>
          <div class="swal-button-container">
            <div
              class="swal-button swal-button--cancel btn btn-default"
              @click="outerVisible = false"
            >取消</div>
          </div>
         
        </div>
      </div>
      <div v-if="EditDialog === 1" class="ModelPadding">
        <div class="swal-title" style="margin-top:0px">新增</div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="150px"
          class="demo-ruleForm"
          style="width:90%"
        >  
          <el-form-item label="上传图片:" prop="">
            <el-upload 
              class="avatar-uploader"
              action
              :show-file-list="false"
              :http-request="uploadPicture">
              <img v-if="imageUrl" :src="imageUrl" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <el-progress :percentage="percentage" :status="percentagestatus" v-if="percentageShow"></el-progress> 
            <span style="color: #F56C6C;font-size: 12px;" v-if="errorTip">必须上传图片</span>
          </el-form-item>
          <el-form-item label="主标题:" prop="title">
            <el-input v-model="ruleForm.title" class="DistributorMargin"></el-input>
          </el-form-item>
          <el-form-item label="副标题:" prop="subTitle">
            <el-input v-model="ruleForm.subTitle" class="DistributorMargin"></el-input>
          </el-form-item>
          <el-form-item label="描述:" prop="description">
            <el-input v-model="ruleForm.description" class="DistributorMargin"></el-input>
          </el-form-item>

          <el-form-item label="是否应用:" prop="status">
             <el-select
              v-model="ruleForm.status"
              placeholder="请选择"
              class="DistributorMargin"
              style="width:100%"
            >
              <el-option
                v-for="item in StateOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
        
          </el-form-item>
        
        </el-form>
        <div class="swal-footer">   
          <div class="swal-button-container">
            <button
              class="swal-button swal-button--confirm btn btn-primary"
              @click="MakeSureEdit('ruleForm')"
              :disabled = "disabled"
            >确定</button>
          </div>
          <div class="swal-button-container">
            <div
              class="swal-button swal-button--cancel btn btn-default"
              @click="outerVisible = false"
            >取消</div>
          </div>
       
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Qs from "qs";
import axios from "axios";
import http from "../../common/http";
import MethodsBus from "../../common/methodBus";
import eventBus from "../../common/eventBus";
export default {
  name: "ProductLogoManagement",
  data() {
    return {
      pageSize: 10,
      totalCount: 0,
      pageindex: 1,
      imageUrl:'',
      outerVisible: false,
      disabled: false,
      EditDialog: 1,
      errorTip: false,
      percentage:0,
      percentageShow: false,
      percentagestatus:'exception',
      CurrentSelection: [],
      StateOptions: [
        {
          label: "是",
          value: 1
        },
        {
          label: "否",
          value: 0
        },
        
      ],
      ruleForm: {
        title: "",
        subTitle: "",
        description: "",
        status: "",
        logoUrl: ""
      },
      rules: {
        title: [{ required: true, message: "请输入主标题", trigger: "blur" }],
        subTitle: [
          { required: true, message: "请输入副标题", trigger: "blur" }
        ],
        description: [
          { required: true, message: "请输入描述", trigger: "blur" }
        ],
        status: [{ required: true, message: "请输入状态", trigger: "blur" }]
      },
      UserManagementEdit: "",
      TimeValue: "",
      UserManagementList: [],
      currentPage: 1,
    };
  },
  mounted: function() {
    this.initdata();
  },
  methods: {
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageindex = 1;
      this.initdata();
    },
    EnlargeImg(row) {
      this.outerVisible = true;
      this.EditDialog = 3;
      this.CurrentSelection = row;
    },
    handleCurrentChange(val) {
      this.pageindex = val;
      this.initdata();
    },
    ApplyClick(item) {
      let that = this;
      const options = {
        url: "distribution/distribution/updateB2cOperateMarketLogo",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          logoId: item.logoId,
          upRecomId: item.upRecomId
        })
      };
      axios(options)
        .then(function(response) {
          that.outerVisible = false;
          if (response.data.code == 200) {
            that.initdata();
            that.$notify({
              title: "成功",
              message: "应用成功",
              type: "success"
            });
          } else {
             http.handleEorrorCode(response,that);
          }
        })
        .catch(function(error) {
          http.handleHttpError(error, that);
        });
    },
    DeleteClick(item) {
      this.outerVisible = true;
      this.EditDialog = 2;
      this.CurrentSelection = item;
    },
    AddClick() {
      this.ruleForm = {};
      this.imageUrl = '';
      if(this.$refs['ruleForm']){
         this.$refs['ruleForm'].resetFields();
      }  
      this.outerVisible = true;
      this.errorTip = false;
      this.percentageShow = false;
      this.EditDialog = 1;
    },
    SearchClick() {
      this.initdata();
    },
    uploadPicture(param) {
      this.imageUrl = URL.createObjectURL(param.file);
      const formData = new FormData();
      formData.append("file", param.file);
      let that = this;
      const options = {
        url: "distribution/FileController/uploadFileToFast",
        method: "post",
        headers: { "Content-Type": "multipart/form-data" },
        data: formData
      };
      axios(options).then(function(response) {
        if (response.data.code == 200) {
          that.ruleForm.logoUrl = response.data.data;
          that.percentageShow =  true;
          setTimeout(()=>{
            that.percentage = 100;
            that.percentagestatus = "success"
          },100)
        } else {
          http.handleEorrorCode(response,that);
        }
      }).catch(function(error) {
        http.handleHttpError(error, that);
      });
    },
    MakeSureEdit(formName) {
      let that = this;
      that.$refs[formName].validate(valid => {
        if (valid && this.ruleForm.logoUrl) {
          if(that.percentage === 100){
            that.disabled = true;
            that.errorTip = false;
            const options = {
              url: "distribution/distribution/addB2cOperateMarketLogo",
              method: "post",
              headers: { "Content-Type": "application/x-www-form-urlencoded" },
              data: Qs.stringify({
                title: this.ruleForm.title,
                subTitle: this.ruleForm.subTitle,
                description: this.ruleForm.description,
                status: this.ruleForm.status,
                logoUrl: this.ruleForm.logoUrl
              })
            };
            axios(options).then(function(response) {
              that.outerVisible = false;
              that.disabled = false;
              if (response.data.code == 200) {
                that.initdata();
                that.$notify({
                  title: "成功",
                  message: "新增成功",
                  type: "success"
                });
              } else {
                http.handleEorrorCode(response,that);
              }
            })
            .catch(function(error) {
              that.outerVisible = false;
              that.disabled = false;
              http.handleHttpError(error, that);
            });
          }else{
            this.outerVisible = true;
            this.errorTip = true;
          }
        }else{
          this.outerVisible = true;
          this.errorTip = true;
        }
      });
    },
    MakeSure() {
      let that = this;
      that.disabled = true;
      const options = {
        url: "distribution/distribution/deleteB2cOperateMarketLogo",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          logoId: this.CurrentSelection.logoId
        })
      };
      axios(options)
        .then(function(response) {
          that.outerVisible = false;
          that.disabled = false;
          if (response.data.code == 200) {
            that.initdata();
            that.$notify({
              title: "成功",
              message: "删除成功",
              type: "success"
            });
          } else {
              http.handleEorrorCode(response,that);
          }
        })
        .catch(function(error) {
            that.outerVisible = false;
          that.disabled = false;
          http.handleHttpError(error, that);
        });
    },
    initdata() {
      let that = this;
      const options = {
        url: "distribution/distribution/queryB2cOperateMarketLogo",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          size: this.pageSize,
          current: this.pageindex
        })
      };
      axios(options)
        .then(function(response) {
          if (response.data.code == 200) {
            that.totalCount = response.data.data.total;
            for (var i in response.data.data.records) {
              response.data.data.records[i].ordernumber =
                Number((that.pageindex - 1) * that.pageSize) + Number(i) + 1;
              if (response.data.data.records[i].status === 0) {
                response.data.data.records[i].currentstatus = "应用";
                response.data.data.records[i].disabled = false;
              } else if (response.data.data.records[i].status === 1) {
                response.data.data.records[i].currentstatus = "已应用";
                response.data.data.records[i].disabled = true;
              }
            }
            that.UserManagementList = response.data.data.records;
          } else {
              http.handleEorrorCode(response,that);
          }
        })
        .catch(function(error) {
          http.handleHttpError(error, that);
        });
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clear {
  clear: both;
}
.PaginationStyle {
  float: right;
  margin-top: 8px;
}
.panelTitle {
  padding-left: 15px;
  text-align: left;
}
.ButtonColor {
  color: #fff !important;
}
.ModelPadding {
  margin-top: -20px;
}
.LineSpacing {
  margin-top: 16px;
}
.LogoImg {
  width: 100px;
  height: 100px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
  border: 1px dashed #8c939d;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/MallPageSetting/ProductLogoManagement.vue